/**
 * Mandatory-marker support for filters and input controls.
 *
 * A filter / input-control config (legacy dashboard `globalFilter[]` items as
 * well as DVM widgetData written by the Layout Builder's Format popup) flags
 * itself as mandatory with `mandatory: true`. The shared controls then render
 * a `*` marker next to their label (`.dvm-mandatory-mark`). The marker is
 * PRESENTATION ONLY — it never blocks a selection; enforcement stays with the
 * consumer (e.g. widget-renderer's `requiredFilterKey`, number-stats'
 * `mandatoryFilters`).
 *
 * `required` / `isMandatory` are accepted as aliases so hand-written legacy
 * configs that already use either spelling light up without edits.
 */

/** Config keys that flag a control as mandatory (first match wins). */
export const MANDATORY_CONTROL_KEYS = ['mandatory', 'required', 'isMandatory'] as const;

/** `true` only on an EXPLICIT true (or the string 'true') on one of the keys. */
export function isMandatoryControl(data: unknown): boolean {
  if (!data || typeof data !== 'object') return false;
  const record = data as Record<string, unknown>;
  return MANDATORY_CONTROL_KEYS.some((key) => {
    const value = record[key];
    return value === true || (typeof value === 'string' && value.trim().toLowerCase() === 'true');
  });
}
